new Vue({
    el: '#contact',
    data: {
        firstname: null,
        lastname: null,
        phone: null,
        email: null,
        message: null,
        isSubmited: false,
        result: false,
        resultMessage: null,
        sendingData: false
    },
    methods: {
        send: function (e) {
            e.preventDefault();
            var _this = this;
            if (_this.sendingData) { return; }
            _this.isSubmited = true;
            _this.resultMessage = null;
            valid = true;
            if (!_this.firstname || !_this.lastname || !_this.phone || !_this.email || !_this.message) {
                valid = false;
            }
            if (valid) {
                _this.sendingData = true;
                axios.post('~/api/contact/send',
                    {
                        firstname: _this.firstname,
                        lastname: _this.lastname,
                        phone: _this.phone,
                        email: _this.email,
                        message: _this.message,
                        captchaVal: $("#g-recaptcha-response").val(),
                        languageId: window.languageId
                    }).then(function (response) {
                        _this.result = response.data.success;
                        _this.resultMessage = response.data.message;
                    }).catch(function (e) {
                        _this.result = false;
                        _this.resultMessage = window.errorPhrase;
                    }).finally(function (e) {
                        _this.sendingData = false;
                    });
            }
            //_this.isSubmited = true;
           
            return false;
        }
    }
})